export * from './server';

/* eslint-disable */
export const ENV = NODE_ENV;
export const SPORT_BASE_PATH = mobileSportBasePath;
export const ISHARE_BASE_PATH = mobileIshareBasePath;
export const CURRENT_BASE_PATH =
    ENV === 'development'
        ? window.location.pathname.startsWith(SPORT_BASE_PATH)
            ? SPORT_BASE_PATH
            : ISHARE_BASE_PATH
        : '';
export const BASENAME = `${CURRENT_BASE_PATH}/loc/worldCup2022`;
export const API_BASE = apiUrl;
/* eslint-enable */

export const IS_GROUNDS = !!window?.grounds;

export const APP_QUERY_LIST = [
    { key: 'isFull', value: '0' },
    { key: 'immersion', value: 'true' },
    { key: 'ifengsp', value: '1' },
];

export const SCHEDULE_STATUS_MAP = {
    CURRENT: 'current',
    AFTER: 'after',
    BEFORE: 'before',
};

export const EVENT_STATUS_MAP = {
    END: 'end',
    CURRENT: 'current',
    NOT_START: 'notStart',
    REPORT: 'report',
};

export const EVENT_STATUS_TEXT_MAP = {
    [EVENT_STATUS_MAP['END']]: '已结束 ',
    [EVENT_STATUS_MAP['CURRENT']]: '进行中 ',
    [EVENT_STATUS_MAP['NOT_START']]: '未开始 ',
    [EVENT_STATUS_MAP['REPORT']]: '战报 ',
};
